import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function WhyFailed() {
  const reasons = ['El cardio excesivo eleva aún más tu cortisol, enviando la señal de "peligro" a tu metabolismo.', 'Las dietas de 1,200 calorías apagan tu tiroides para ahorrar energía, deteniendo la pérdida de peso.', 'Los productos "light" llenos de edulcorantes engañan a tu insulina y aumentan tus antojos nocturnos.'];
  return <section className="py-20 px-6 bg-charcoal text-cream" data-id="element-202">
      <div className="max-w-4xl mx-auto" data-id="element-203">
        <FadeIn data-id="element-204">
          <h2 className="font-serif text-3xl md:text-4xl mb-12 text-center" data-id="element-205">
            Por qué lo que intentaste no funcionó
          </h2>
          <div className="space-y-6 mb-12" data-id="element-206">
            {reasons.map((reason, index) => <div key={index} className="flex items-start gap-4 bg-white/5 p-6 rounded-xl" data-id="element-207">
                <XCircle className="text-terracotta shrink-0 mt-1" size={24} data-id="element-208" />
                <p className="font-sans text-lg leading-relaxed" data-id="element-209">{reason}</p>
              </div>)}
          </div>
          <p className="text-center font-serif text-xl md:text-2xl italic text-cream/90 max-w-2xl mx-auto" data-id="element-210">
            "Seguir las reglas de nutrición de tus 20 años en un cuerpo de 40 es
            como usar un software viejo en una computadora nueva: el sistema
            simplemente colapsa."
          </p>
        </FadeIn>
      </div>
    </section>;
}